import { StyleSheet, View } from "react-native";
import CustomText from "../general/CustomText/CustomText";

const Pill = ({
  text,
  leftIcon,
  backgroundColor,
  textColor,
  textSize = "s",
  borderColor = "transparent",
  borderWidth = 0,
  updated = false,
}: {
  text?: string;
  leftIcon?: JSX.Element;
  backgroundColor?: string;
  textColor?: string;
  textSize?: "xs" | "s" | "m" | "l";
  borderColor?: string;
  borderWidth?: number;
  updated?: boolean;
}) => {
  return (
    <View
      style={[
        styles.pill,
        {
          backgroundColor: backgroundColor || "transparent",
          borderColor: borderColor || "transparent",
          borderWidth: borderWidth ?? 0,
        },
        updated ? { paddingHorizontal: 10, paddingVertical: 2 } : {},
      ]}>
      {leftIcon && leftIcon}
      {text && <CustomText text={text} size={textSize} style={{ color: textColor }} useTranslationText={false} />}
    </View>
  );
};

export default Pill;

const styles = StyleSheet.create({
  pill: {
    borderRadius: 360,
    paddingHorizontal: 12,
    paddingVertical: 4,
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
});
